<!-- 轮播图列表 -->
<template>
  <div class="vue">
    <div class="header flex flexAi-c">
      <div class="text">轮播图列表</div>
      <a-button @click="addbannerBut" round type="primary" size="small"
        >添加轮播图</a-button
      >
    </div>
    <div class="content ">
      <div class="table-head flex  flexAi-c"></div>
      <a-table
        :columns="columns"
        :scroll="{ y: 400 }"
        :data-source="bannerList"
        :pagination="false"
      >
        <template slot="img" slot-scope="text">
          <img style="max-width:30%" :src="text" />
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="operation flex">
            <div class="editable-row-operations">
              <!-- <router-link
                :to="{
                  path: '/AddBanner',
                  query: { bannerObj: JSON.stringify(record) }
                }"
              > -->
              <a @click="editClick(record)">编辑</a>
              <!-- </router-link> -->
            </div>
            <div class="editable-row-operations">
              <a-popconfirm
                ok-text="是"
                cancel-text="否"
                title="确定要发布并进行推送通知?"
                @confirm="() => cancel(record)"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </div>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: [''],
  data() {
    return {
      bannerList: [], // 用户数据
      // 表格名称
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '名称',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '图片',
          dataIndex: 'img',
          scopedSlots: { customRender: 'img' }
        },
        {
          title: '路径',
          dataIndex: 'url',
          scopedSlots: { customRender: 'url' }
        },
        {
          title: '排序',
          dataIndex: 'sequence',
          scopedSlots: { customRender: 'sequence' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },

  computed: {},
  beforeRouteLeave(to, from, next) {
    console.log(from.meta)
    if (from.meta.keepAlive) {
      from.meta.scollTopPosition = 'true'
    }
    next()
  },
  beforeRouteEnter(to, from, next) {
    console.log(from)

    next(vm => {
      if (from.path === '/backstageIndex/AddBanner') {
        vm.CarouselFindAll()
      }
    })
  },
  mounted() {
    this.CarouselFindAll()
  },

  methods: {
    // 新增
    addbannerBut() {
      this.$router.push({
        path: '/backstageIndex/AddBanner'
      })
    },

    /* 列表 */
    // 删除
    cancel(row) {
      this.$postAxios('/carousel/delCarousel', {
        id: row.id
      }).then(res => {
        if (res.status === '0') {
          this.$Ms(res.msg)
          this.CarouselFindAll()
        } else if (res.status === '1') {
          this.$Me(res.msg)
        }
      })
    },
    // 编辑
    editClick(row) {
      this.$router.push({
        path: '/backstageIndex/AddBanner',
        query: {
          info: this.$Base64.encode(JSON.stringify(row))
        }
      })
    },
    // 接口
    // 获取列表
    CarouselFindAll() {
      this.bannerList = []
      this.$postAxios('/carousel/findAll').then(res => {
        if (res.status === '0') {
          this.bannerList = res.data
        } else if (res.status === '1') {
          this.$message.error(res.msg)
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
$colorMajor: #2b9dcf;
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-left: 2px solid $colorMajor;
  .header {
    justify-content: space-between;
    border-bottom: 2px solid #f3f3f3;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: $colorMajor;
      padding: 10px 5px;
    }
  }
  .content {
    padding: 10px 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // 编辑
    .ant-table-tbody {
      .operation {
        /deep/ .editable-row-operations {
          padding: 0 5px;
          .remove {
            color: red;
          }
          .operation-span {
            .sure {
              color: #0091ff;

              padding-right: 5px;
            }
            .operation-cancel {
              color: #ff5252;
            }
          }
        }
      }
      .userSter {
        a:last-child {
          padding-left: 10px;
        }
      }
    }
    // 分页样式
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
